export default __webpack_public_path__ + "static/media/Blade's Grips of Waning Dusk.708d2f6e.jpg";